import userSegmentTypes from '../../../../consts/loyalty/userSegmentTypes';
import loyaltySourcingService from '../../../../services/loyalty/loyaltySourcingService';
import {selectLoyaltyUserData} from '../../../../state/selectors/loyalty';
import {setLoyaltyUserData} from '../../../../state/slice/loyalty';
import {dispatch, getState} from '../../../../state/store';
import stringUtils from '../../../../utils/stringUtils';
import {twx} from '../../../../utils/tailwindUtils';
import SettingsSection from './SettingsSection';

const CONFIG = [
    {
        id: 0,
        name: 'userSegment',
        values: [
            userSegmentTypes.SPRINT,
            userSegmentTypes.MILD,
            userSegmentTypes.REGULAR,
            userSegmentTypes.CHILLED,
            userSegmentTypes.ALLERT,
        ],
    },
    {
        id: 1,
        name: 'sourcing',
        values: [
            userSegmentTypes.CC,
            userSegmentTypes.COMP_HNB,
            userSegmentTypes.EVAPE_DUAL,
            userSegmentTypes.POLY_HNB,
        ],
    },
    {
        id: 2,
        name: 'motivation',
        values: [userSegmentTypes.HIGH, userSegmentTypes.MID, userSegmentTypes.LOW],
    },
    {
        id: 3,
        name: 'reason',
        values: [userSegmentTypes.SOCIAL, userSegmentTypes.TASTE, userSegmentTypes.AESTHETIC],
    },
    {
        id: 4,
        name: 'isConsecutive3Days',
        values: [true, false],
        isBooleanType: true,
    },
];

const SegmentsPanel = ({onClose}) => {
    const userData = selectLoyaltyUserData(getState());

    const onChange = (name, item, isActive) => {
        if (name === 'sourcing') {
            const currentItems = userData?.[name] || [];
            const updatedItems = isActive ? currentItems.filter((i) => i !== item) : [...currentItems, item];

            dispatch(setLoyaltyUserData({...userData, [name]: updatedItems}));
            return;
        }

        if (name === 'isConsecutive3Days') {
            dispatch(setLoyaltyUserData({...userData, [name]: item}));
            return;
        }

        dispatch(setLoyaltyUserData({...userData, [name]: isActive ? null : item}));
    };

    const userSegmentArray = loyaltySourcingService.getUserSegmentTypes();

    return (
        <>
            <div className='fixed inset-0 z-[1002] bg-black/40 backdrop-blur-sm' onClick={onClose} />
            <div className='fixed inset-x-4 top-[15%] z-[1003] mx-auto max-w-[560px]'>
                <div className='relative max-h-[70vh] overflow-y-auto rounded-2xl bg-white p-4 text-color-primary shadow-xl'>
                    <div className='flex flex-col gap-4'>
                        {CONFIG.map(({name, values, id, isBooleanType}) => (
                            <SettingsSection key={id} title={stringUtils.capitalizeFirstLetter(name)}>
                                {values.map((item, index) => {
                                    let isActive;

                                    if (isBooleanType) {
                                        isActive = item === userData?.[name];
                                    } else {
                                        isActive = userSegmentArray.includes(item);
                                    }

                                    return (
                                        <div
                                            key={index}
                                            className={twx(
                                                'flex cursor-pointer items-center justify-between px-4 py-3 active:bg-gray-100',
                                                isActive && 'bg-gray-100'
                                            )}
                                            onClick={() => onChange(name, item, isActive)}
                                        >
                                            <span className='text-sm'>{item.toString()}</span>
                                            {isActive && <span className='text-sm text-color-tertiary'>✓</span>}
                                        </div>
                                    );
                                })}
                            </SettingsSection>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SegmentsPanel;
